import {
  SET_CHAT_HEADER_TITLE,
  SET_CHAT_SUBTITLE,
  SET_CHAT_PARM_ENABLE_TEXT_AREA,
  SET_CHAT_PARM_LANGUAGE,
  SET_CHAT_WIDGET_OPENED,
  SET_UNREAD_MESSAGE_COUNT,
  RENDER_CHAT,
} from "../actions/types";

// let language  - done
// let enableTextArea - done
const initialState = {
  chatTitle: "",
  chatSubtitle: undefined,
  chatParmEnableTextArea: false,
  chatParmLanguage: "",
  chatWidgetOpened: false,
  unreadMessageCount: 0,
  render: { loaderPane: { loaderMessage: "chatConfigLoading" } },
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case SET_CHAT_HEADER_TITLE:
      return { ...state, chatTitle: action.payload };

    case SET_CHAT_SUBTITLE:
      return { ...state, chatSubtitle: action.payload };

    case SET_CHAT_PARM_ENABLE_TEXT_AREA:
      return { ...state, chatParmEnableTextArea: action.payload };

    case SET_CHAT_PARM_LANGUAGE:
      return { ...state, chatParmLanguage: action.payload };

    case SET_CHAT_WIDGET_OPENED:
      return { ...state, chatWidgetOpened: action.payload };

    case SET_UNREAD_MESSAGE_COUNT:
      return { ...state, unreadMessageCount: action.payload };

    case RENDER_CHAT:
      return { ...state, render: action.payload };

    default:
      return state;
  }
}
